module.exports = __webpack_public_path__ + "images/emoji/wave.4731525da99dd7a6c533.png";